export default function($) {
  if ($('body').hasClass('single-post')) {
    var scroll_timeout = 0;

    $('.blog__title__container').removeClass('initial-load');
    setTimeout(function() {
      $('.blog__title__container').addClass('loaded')
    }, 1000);

    function titleScroll() {
      if ($('.blog__title__container').hasClass('loaded')) {
        if ($('.blog__title__container').css('position') === 'absolute') {
          var title_total_scroll = $('.blog__header__wrapper').offset().top + $('.blog__header__wrapper').height() - $('.blog__title__container').height();
          var scroll_percentage = $(window).scrollTop() / title_total_scroll / 2.5;

          var opacity = 1 - scroll_percentage * 2.5;
          var bottom = `calc(60px + ${scroll_percentage * 100}%)`;

          $('.blog__title__container').css('opacity', opacity);
          $('.blog__title__container').css('bottom', bottom);
        } else {
          $('.blog__title__container').css('opacity', 1);
          $('.blog__title__container').css('bottom', 'auto');
        }
      }
    }

    function throttleScroll() {
      if (Date.now() >= scroll_timeout + 10) {
        scroll_timeout = Date.now();
        titleScroll();
      }
    }

    $(window).on('scroll', throttleScroll);
    $(window).on('resize', throttleScroll);
  }
}
